module.exports = __webpack_public_path__ + "img/THQ_Screen_2.27a58161.jpg";